import { AttachedContext } from './AttachedContext';
export class AttachedActionContext extends AttachedContext {
    event_stored;
    constructor({ event, at }) {
        super(at);
        this.event_stored = event;
    }
    get event() {
        return this.event_stored;
    }
    get e() {
        return this.event.rawEvent;
    }
    get keyboardEvent() {
        return this.event;
    }
    get mouseEvent() {
        return this.event;
    }
    get draggableEvent() {
        return this.event;
    }
}
